import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CartNotification from '../../navbar/top/CartNotification';
import NotificationDropdown from '../top/NotificationDropdown';
import ProfileDropdown from '../top/ProfileDropdown';
import AppContext from '../../../context/Context';
import React, { useContext, useEffect, useState } from 'react';
import { Nav, OverlayTrigger, Tooltip, Button, Form } from 'react-bootstrap';
import NineDotMenu from './NineDotMenu';
import CreditBalance from './CreditBalance';
import queryString from 'query-string';
import HelpDocDropDown from './HelpDocDropDown';
import VanAccountModal from './VanAccountModal';
import VanAccountNavButton from './VanAccountNavButton';
import { updateLanguage } from '../../../app/common/slices/navbarTop';
import { useDispatch, useSelector } from 'react-redux';
import { getLanguageList } from '../../../app/features/dashboard/actions/instruction';
import axiosInstance from '../../../axiosSetup';
import { AESDecryptAny } from '../../../encrypt-util';

const TopNavRightSideNavItem = () => {
  const {
    config: { isDark, isRTL },
    setConfig,
  } = useContext(AppContext);

  const [showSwitchApps, setShowSwitchApps] = useState(false);
  const [showVanModal, setShowVanModal] = useState(false);

  const languageList = useSelector((state) => state.navbarTop.languageList);
  const profileDetails = useSelector((state) => state.userProfile.profile);
  const linerDataCountry = useSelector(
    (state) => state.userProfile.linerDataCountry
  );

  const storedUserCountry =
    AESDecryptAny(window.localStorage.getItem('@user-selected-datacountry')) || [];

  const storedCountry =
    storedUserCountry?.[0]?.loginId === profileDetails.email
      ? storedUserCountry?.[0]?.country
      : null;

  const dataCountry = storedCountry
    ? storedCountry
    : linerDataCountry
      ? linerDataCountry
      : profileDetails.partnerCountry || null;

  const language = useSelector((state) => state.navbarTop.language);
  const dispatch = useDispatch();
  const linerId = useSelector((state) => state.navbarTop.linerId);

  useEffect(() => {
    if (dataCountry && linerId) {
      dispatch(getLanguageList({ dataCountry, linerId }))
        .unwrap()
        .then((list) => {
          if(!list || list?.length==0)
          {
      localStorage.removeItem('selectedLanguage',"EN")
          }
          const selectedLang =
            localStorage.getItem('selectedLanguage') || list?.[0]?.lang || 'EN';
          dispatch(updateLanguage(selectedLang));
        })
        .catch(()=>{
            localStorage.removeItem('selectedLanguage')
        });
    }
  }, [dataCountry, linerId, localStorage.getItem('selectedLanguage')]);

  useEffect(() => {
    const fetchAppList = async () => {
      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_GATEWAY_HOST}/api/user-management/v1/app/appList`
        );
        if (Array.isArray(response.data) && response.data.length > 1) {
          setShowSwitchApps(true);
        }
      } catch (err) {
        console.error('Error fetching app list:', err);
      }
    };

    fetchAppList();
  }, []);

  return (
    <>
      <Nav
        navbar
        className='navbar-nav-icons ms-auto flex-row align-items-center'
        as='ul'>
      {/* <Nav.Item as={'li'}>
        <Nav.Link
          className='px-2 theme-control-toggle'
          onClick={() => setConfig('isDark', !isDark)}
        >
          <OverlayTrigger
            key='left'
            placement={isRTL ? 'bottom' : 'left'}
            overlay={
              <Tooltip id='ThemeColor'>
                {isDark ? 'Switch to light theme' : 'Switch to dark theme'}
              </Tooltip>
            }
          >
            <div className='theme-control-toggle-label'>
              <FontAwesomeIcon
                icon={isDark ? 'sun' : 'moon'}
                className='fs-0'
              />
            </div>
          </OverlayTrigger>
        </Nav.Link>
      </Nav.Item> */}

      {/* <CartNotification /> */}
      {/* <NineDotMenu /> */}

      {AESDecryptAny(window.localStorage.getItem('@odex/activeuser') === 'liner') || true ? (
        ''
      ) : (
        <CreditBalance />
      )}

      <NotificationDropdown />

      {languageList.length > 1 && (
        <Form.Select
          aria-label='Carrier'
          className='rounded-pill mx-3 d-flex justify-content-end text-primary bg-100 fs--1 h-100'
          onChange={(e) => {
            const selectedLang = e?.target?.value;
            localStorage.setItem('selectedLanguage', selectedLang);
            dispatch(updateLanguage(selectedLang));
          }}
          value={localStorage.getItem('selectedLanguage') || language}
        >
          {languageList?.map((option) => (
            <option className='text-dark' key={option.lang} value={option.lang}>
              {option.text}
            </option>
          ))}
        </Form.Select>
      )}

      {showSwitchApps && (
        <div
          className='h-full px-2'
          style={{
            paddingTop: '10px',
            paddingBottom: '10px',
            borderRadius: '8px',
            border: '1px solid #ccc',
            backgroundColor: '#f8f9fa',
          }}
        >
          <span>
            <a href='/app'>Switch Apps</a>
          </span>
        </div>
      )}

      {dataCountry === 'DJ' ||dataCountry === 'AE' && (
        <VanAccountNavButton/*  onOpen={() => setShowVanModal(true)}  *//>
      )}
      <HelpDocDropDown />
      <ProfileDropdown />
      </Nav>
      {dataCountry === 'DJ' || dataCountry === 'AE' && (
        <VanAccountModal
          show={showVanModal}
          onHide={() => setShowVanModal(false)}
        />
      )}
    </>
  );
};

export default TopNavRightSideNavItem;
